import { render, staticRenderFns } from "./RemolqueDocumento.vue?vue&type=template&id=5e4222fc"
import script from "./RemolqueDocumento.vue?vue&type=script&lang=js"
export * from "./RemolqueDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports